import { useMemo } from 'react';
import Role from 'crono-fe-common/types/enums/role';
import { useAuth } from 'context/auth';

export function useRoleCapabilities() {
  const { user } = useAuth();
  return useMemo(() => {
    const roles = user?.userRoles ?? [];
    const hasManager = roles.includes(Role.MANAGER);
    return {
      isManager: hasManager,
      canManageSubscription: roles.includes(Role.SUBSCRIPTION_MANAGER),
      hasAppAccess: roles.includes(Role.BASIC) || hasManager,
    };
  }, [user?.userRoles]);
}
